/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Typography } from "@material-ui/core";
import Product from "./ProductList";
import PizzaData from "../data/PizzaData";
import PizzaCarousel from "../data/PizzaCarousel";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "1rem 0rem 2rem 0rem",
    gap: "1rem",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
      justifyContent: "center",
      marginTop: "1rem",
    },
  },
  items: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
  },
  text: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    width: "100%",
  },
  heading: {
    width: "100%",
    color: "#000000",
    fontWeight: "700",
    fontSize: "2.125rem",
    lineHeight: "5.625rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.125rem",
      lineHeight: "3.1875rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.5rem",
      lineHeight: "2.25rem",
    },
  },
  boldgreen: {
    color: "#75E88A",
    // fontWeight: "bold",
    background: "-webkit-linear-gradient(90deg, #75E88A, #2CB646)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  slider: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "100%",
  },
  illustrationSizer: {
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      height: "280px",
      width: "280px",
    },
    [theme.breakpoints.only("xs")]: {
      height: "320px",
      width: "320px",
    },
    [theme.breakpoints.only("sm")]: {
      height: "352px",
      width: "352px",
    },
    [theme.breakpoints.only("md")]: {
      height: "384px",
      width: "384px",
    },
    [theme.breakpoints.only("lg")]: {
      height: "512px",
      width: "512px",
    },
    [theme.breakpoints.only("xl")]: {
      height: "512px",
      width: "512px",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      height: "768px",
      width: "768px",
    },
  },
}));

const Pizza = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      {/* <div className={classes.slider}>
        <img
          src="/images/dishes/salad.png"
          alt={AppConfig.imageAltText}
          width={512}
          height={512}
          loading="eager"
          referrerPolicy="no-referrer"
          longdesc="https://psolifestyle.com"
          className={classes.illustrationSizer}
        />
      </div> */}
      <div className={classes.sectionContainer}>
        <div className={classes.slider}>
          <PizzaCarousel />
        </div>
        <div className={classes.items}>
          <div className={classes.text}>
            <Typography variant="h4" component="h4" className={classes.heading}>
              <span className={classes.boldgreen}>PIZZA</span>
            </Typography>
          </div>
          {PizzaData.map((object, key) => {
            return (
              <Product
                key={key}
                productname={object.productname.toUpperCase()}
                productdescription={object.productdescription}
              />
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Pizza;
